import React from 'react';

const HomeSkeleton = () => {
    return (
        <main className="bg-slate-50/50 min-h-screen pb-2">
            {/* Banner Skeleton */}
            <div className="w-full mb-2">
                <div className="w-full h-44 sm:h-60 md:h-76 bg-slate-200 animate-pulse mb-2" />
            </div>

            <div className="view-section p-4">
                {/* Shop by Category Skeleton */}
                <section className="mb-5">
                    <div className="flex items-center justify-between mb-2">
                        <div>
                            <div className="h-6 sm:h-7 w-44 bg-slate-200 animate-pulse rounded mb-1"></div>
                            <div className="h-4 w-32 bg-slate-200 animate-pulse rounded"></div>
                        </div>
                    </div>

                    <div className="w-full overflow-hidden pb-2 mt-2 flex flex-col gap-3">
                        <div className="flex justify-between md:justify-start md:gap-4 w-full overflow-hidden">
                            {[...Array(6)].map((_, i) => (
                                <div key={`cat-skel-1-${i}`} className="flex-shrink-0 w-20 text-center">
                                    <div className="w-16 h-16 mx-auto rounded-xl bg-slate-200 animate-pulse mb-2"></div>
                                    <div className="h-3 w-12 mx-auto bg-slate-200 animate-pulse rounded"></div>
                                </div>
                            ))}
                        </div>
                        <div className="hidden md:flex md:gap-4 w-full overflow-hidden">
                            {[...Array(6)].map((_, i) => (
                                <div key={`cat-skel-2-${i}`} className="flex-shrink-0 w-20 text-center">
                                    <div className="w-16 h-16 mx-auto rounded-xl bg-slate-200 animate-pulse mb-2"></div>
                                    <div className="h-3 w-12 mx-auto bg-slate-200 animate-pulse rounded"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Featured Brands Skeleton */}
                <section className="mb-5">
                    <div className="flex items-center justify-between mb-2">
                        <div>
                            <div className="h-5 sm:h-6 w-36 bg-slate-200 animate-pulse rounded mb-1"></div>
                            <div className="h-4 w-24 bg-slate-200 animate-pulse rounded"></div>
                        </div>
                    </div>

                    <div className="w-full overflow-hidden pb-2 mt-2 flex flex-col gap-3">
                        <div className="flex justify-between md:justify-start md:gap-4 w-full overflow-hidden">
                            {[...Array(6)].map((_, i) => (
                                <div key={`brand-skel-1-${i}`} className="flex-shrink-0 w-20 text-center">
                                    <div className="w-16 h-16 mx-auto rounded-xl bg-slate-200 animate-pulse mb-2"></div>
                                    <div className="h-3 w-12 mx-auto bg-slate-200 animate-pulse rounded"></div>
                                </div>
                            ))}
                        </div>
                        <div className="hidden md:flex md:gap-4 w-full overflow-hidden">
                            {[...Array(6)].map((_, i) => (
                                <div key={`brand-skel-2-${i}`} className="flex-shrink-0 w-20 text-center">
                                    <div className="w-16 h-16 mx-auto rounded-xl bg-slate-200 animate-pulse mb-2"></div>
                                    <div className="h-3 w-12 mx-auto bg-slate-200 animate-pulse rounded"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Trending Products Skeleton */}
                <section className="mb-5">
                    <div className="flex items-end justify-between mb-2">
                        <div>
                            <div className="h-5 sm:h-6 w-48 bg-slate-200 animate-pulse rounded mb-1"></div>
                            <div className="h-4 w-36 bg-slate-200 animate-pulse rounded"></div>
                        </div>
                    </div>

                    <div className="grid gap-2 sm:gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-5 2xl:grid-cols-6">
                        {[...Array(6)].map((_, i) => (
                            <div
                                key={`prod-skel-${i}`}
                                className="relative bg-white rounded-2xl border border-[#0F766E]/5 shadow-[0_8px_24px_rgba(15,118,110,0.08)] w-full flex flex-col p-3 sm:p-4 h-full animate-pulse min-h-[260px]"
                            >
                                <div className="flex justify-between items-start w-full min-h-[22px] mb-2.5">
                                    <div className="h-4 w-20 bg-slate-200 rounded-full"></div>
                                    <div className="h-4 w-16 bg-slate-200 rounded-full"></div>
                                </div>

                                <div className="h-5 bg-slate-200 rounded w-3/4 mb-1"></div>
                                <div className="h-3 bg-slate-200 rounded w-1/3 mb-2.5"></div>

                                <div className="flex gap-3 mb-2">
                                    <div className="w-24 sm:w-28 h-24 sm:h-28 bg-slate-200 rounded shrink-0"></div>
                                    <div className="flex-1 space-y-2 py-1">
                                        <div className="h-3 bg-slate-200 rounded w-full"></div>
                                        <div className="h-3 bg-slate-200 rounded w-5/6"></div>
                                        <div className="h-3 bg-slate-200 rounded w-4/6"></div>
                                        <div className="flex gap-1 mt-2">
                                            <div className="h-4 w-12 bg-slate-200 rounded-sm"></div>
                                            <div className="h-4 w-14 bg-slate-200 rounded-sm"></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-auto flex flex-col gap-2.5">
                                    <div className="flex items-center justify-between border-t border-slate-100 pt-2">
                                        <div className="h-3 w-20 bg-slate-200 rounded"></div>
                                        <div className="h-4 w-16 bg-slate-200 rounded-full"></div>
                                    </div>

                                    <div className="flex items-center gap-3">
                                        <div className="h-3 w-20 bg-slate-200 rounded"></div>
                                        <div className="w-px h-3 bg-slate-200"></div>
                                        <div className="h-3 w-20 bg-slate-200 rounded"></div>
                                    </div>

                                    <div className="flex items-center justify-between gap-2 pt-1">
                                        <div className="h-8 w-28 bg-slate-200 rounded"></div>
                                        <div className="h-8 w-24 bg-slate-200 rounded-md ml-auto"></div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </main>
    );
};

export default HomeSkeleton;
